class DtFestivalCollectionFilter extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
    DtFestivalCollectionFilter.prepareHistoryState(this.dataset.currentPath);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.abortController?.abort();
  }

  static prepareHistoryState(path) {
    if (!path || history.state?.dtFestivalFilterPath === path) return;

    history.replaceState(
      {
        ...(history.state || {}),
        searchParams: window.location.search.slice(1),
        dtFestivalFilterPath: path,
      },
      '',
      window.location.href,
    );
  }

  onClick(event) {
    const link = event.target.closest('[data-dt-festival-filter-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const target = new URL(link.href, window.location.href);
    if (target.origin !== window.location.origin) return;

    event.preventDefault();
    target.search = window.location.search;
    target.hash = 'festival-products';
    this.render(target, { updateHistory: true, restoreFocus: true });
  }

  async render(target, { updateHistory = false, restoreFocus = false } = {}) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    this.abortController?.abort();
    this.abortController = new AbortController();
    this.setAttribute('aria-busy', 'true');

    const requestUrl = new URL(target, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(requestUrl, { signal: this.abortController.signal });
      if (!response.ok) throw new Error(`Campaign filter request failed with ${response.status}`);

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector(`dt-festival-collection-filter[data-section-id="${CSS.escape(sectionId)}"]`);
      if (!next) throw new Error('Campaign filter response did not include the product grid.');

      const destination = new URL(target, window.location.origin);
      if (updateHistory) {
        history.pushState(
          {
            searchParams: destination.search.slice(1),
            dtFestivalFilterPath: destination.pathname,
          },
          '',
          `${destination.pathname}${destination.search}${destination.hash}`,
        );
      }

      this.replaceWith(next);

      const status = next.querySelector('[data-dt-festival-filter-status]');
      const productCount = next.querySelector('#ProductCount')?.textContent?.trim();
      const activeLabel = next.querySelector('[data-dt-festival-filter-link][aria-current="page"]')?.textContent?.trim();
      if (status && productCount) status.textContent = `${activeLabel || 'All'}: ${productCount}`;

      if (restoreFocus) {
        next.querySelector('[data-dt-festival-filter-link][aria-current="page"]')?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(target);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('dt-festival-collection-filter')) {
  customElements.define('dt-festival-collection-filter', DtFestivalCollectionFilter);
}

if (!window.dtFestivalFilterHistoryListener) {
  window.dtFestivalFilterHistoryListener = true;
  window.addEventListener('popstate', () => {
    const filter = document.querySelector('dt-festival-collection-filter');
    if (!filter || filter.dataset.currentPath === window.location.pathname) return;
    filter.render(window.location.href);
  });
}
